/** @format */
import { localeServiceModule } from 'sis-common';

export const commonCodeFilterModule = 'sis-components.string.codeFilter';

('use strict');
(function () {
    codeLocalizedName.$inject = ['localeService'];
    angular.module(commonCodeFilterModule, [localeServiceModule]).filter('codeLocalizedName', codeLocalizedName);

    function codeLocalizedName(localeService) {
        return function (input) {
            if (input && input.name) {
                return input.name[localeService.getCurrentLocale()] || input.name.fi || input.name.en || input.name.sv;
            }
            return '';
        };
    }
})();
